module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-button"
  }, [_c('div', {
    staticClass: "page-button-swapper"
  }, [_c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "back",
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more",
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "13px",
      "width": "13px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "back",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "14px",
      "width": "14px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "large",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "large",
      "type": "primary"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "icon": "back",
      "type": "primary",
      "iconSize": "24px"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "icon": "more",
      "type": "primary",
      "iconSize": "24px"
    }
  }, [_vm._v("primary")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "20px",
      "width": "20px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "small",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "small",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "back",
      "size": "small",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more",
      "size": "small",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "type": "default"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "13px",
      "width": "13px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "back",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "default"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "14px",
      "width": "14px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "large",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "large",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "icon": "back",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "icon": "more",
      "type": "default"
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "default"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "20px",
      "width": "20px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "small",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "small",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "back",
      "size": "small",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more",
      "size": "small",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "13px",
      "width": "13px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "back",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "warning"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "14px",
      "width": "14px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "large",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "large",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "icon": "back",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "icon": "more",
      "type": "warning"
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "warning"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "20px",
      "width": "20px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-button-group"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "back",
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more",
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "13px",
      "width": "13px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "back",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "danger"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "14px",
      "width": "14px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "disabled": "",
      "size": "large",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "plain": "",
      "size": "large",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "icon": "back",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "icon": "more",
      "type": "danger"
    }
  }, [_vm._v("danger")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "danger"
    }
  }, [_c('mt-image', {
    attrs: {
      "slot": "icon",
      "src": "http://res.wisedu.com/fe_components/images/errorTip/System_upgrade.png",
      "height": "20px",
      "width": "20px"
    },
    slot: "icon"
  }), _vm._v("自定义图标\n      ")], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b69585","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/button.vue
// module id = 102
// module chunks = 0